import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { ProfileContext, logout, useRouter } from '@loyalup/core';

import { ReactComponent as HelpIcon } from 'icons/menu-help.svg';
import { ReactComponent as QuitIcon } from 'icons/menu-quit.svg';
import { ReactComponent as AvatarIcon } from 'icons/avatar.svg';

import s from './Topbar.module.css';

const Topbar = () => {
  const { Link } = useRouter();
  const { user, company, isAdmin } = useContext(ProfileContext);
  const [t] = useTranslation();

  const openJivoChat = () => {
    window.jivo_api.open();
  };

  return (
    <div className={s.root}>
      <Link to="/settings/me" className={s.userInfo}>
        <div className={s.userName}>
          {user.fullName}
          {!isAdmin && <span>{company.name}</span>}
        </div>
        <div className={s.userpic}>
          {user.userpicImage ? (
            <img alt="avatar" className={s.avatarImage} src={user.userpicImage.url80} />
          ) : (
            <AvatarIcon />
          )}
        </div>
      </Link>
      {!isAdmin && (
        <button onClick={openJivoChat} className={s.button}>
          <HelpIcon />
          {t('Помощь')}
        </button>
      )}
      <button
        className={s.button}
        onClick={() => {
          logout();
          window.location = '/';
        }}
      >
        <QuitIcon />
        {t('Выйти')}
      </button>
    </div>
  );
};

export default Topbar;
